<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>
import findIndex from 'lodash/findIndex'

import Scroller from '@/components/scroller'
import Slider from '@/components/slider/slider'

export default {

  name: 'TheFooter',

  components: {
    Slider
  },

  data () {
    return {
      social: [ 'facebook', 'behance', 'instagram' ]
    }
  },

  computed: {
    slides () {
      const slides = this.$store.state.app.meta.pages
      const filtered = slides.filter(slide => !slide.url.match(/main/))

      const current = findIndex(filtered, slide => !!this.$route.path.match(new RegExp(slide.url)))

      if (current === -1) return filtered

      const sorted = filtered.concat(filtered.splice(0, current + 1))

      return sorted.filter(slide => !this.$route.path.match(new RegExp(slide.url)))
    },
  },

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

footer.footer
  .footer-main
    .footer-slider
      .footer-slider__main
          slider(:slideList="slides")
  .footer-mini
    .footer-mini__column
      .copyright
        p.copyright__text {{ $t('copyright') }}

    .footer-mini__column
      a.footer-email(:href="`mailto:${$t('contact-email')}`" target="_blank") {{ $t('contact-email') }}
      ul.footer-social
        li.footer-social__item(v-for="item in social" v-if="$t(item + '-link').length > 0")
          a.footer-social__link(:href="$t(item + '-link')" target="_blank") {{ $t('social-' + item) }}

    //- .footer-mini__column
    //-   p
    //-     | Дизайн сделан в
    //-     a(:href="mono" target="_blank").mono-link: .mono-link__logo

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.footer
  display flex
  flex-direction column
  +mobile()
    justify-content: center
    height: 100vh

.footer-main
  display flex
  flex-direction column
  height 510px
  padding-top 110px

  +mobile()
    padding-top 0
    height auto

// ===========================================
// Slider
// ===========================================

.footer-slider
  position relative
  display flex
  width 100%
  height 100%

  &__main
    width 100%
    height 100%

// ===========================================
// Mini
// ===========================================

.footer-mini
  display flex
  justify-content space-between
  width 100%
  height 180px
  padding 0 65px 60px
  font-size 12px

  +mobile()
    flex-direction column-reverse
    padding 0 15px 0px
    height: auto

  &__column
    width 40%
    display flex
    flex-direction column
    justify-content flex-end

    +mobile()
      width 100%
      justify-content center
      align-items center

    &.is-middle
      align-items center
      justify-content center

    &:last-child
      align-items flex-end

      +mobile()
        justify-content center
        align-items center

.footer-email
  font-weight 500
  font-size 16px
  color blue
  transition color .2s
  padding 10px

  &:hover
    color light-blue

.copyright
  display: block;
  padding: 25px 20px;

  +mobile()
    padding:15px;

.footer-social
  flex 0 0 auto
  display flex
  list-style-type none
  margin-right -12px

  +mobile()
    margin-bottom 0

  &__item
    display block
    position relative
    margin-left 2px
    margin-right 3px

    &:not(:first-child):before
      content ''
      position absolute
      top 0
      left -5px
      bottom 0
      margin auto 0
      display block
      width 5px
      height 5px
      background-color #e8e8e8

  &__link
    display block
    padding 25px 20px
    font-size 12px
    color dark
    transition color .2s

    +mobile()
      padding: 10px

    &:hover
      color light-blue

.mono-link
  position relative
  display inline-block
  margin-left 10px
  width 42px
  height 12px

  &__logo
    display inline-block
    width 100%
    height 100%
    margin-bottom -1px

    &:before
    &:after
      content ''
      position absolute
      top -10px
      left -10px
      display block
      width calc(100% + 20px)
      height calc(100% + 20px)
      background-size auto
      background-repeat no-repeat
      background-position center
      transition opacity .2s, visibility .2s

    &:before
      z-index 1
      background-image url('/public/images/mono-logo.svg')

    &:after
      z-index 2
      background-image url('/public/images/mono-logo-light.svg')
      opacity 0
      visibility hidden

  &:hover &__logo:before
    opacity 0
    visibility hidden

  &:hover &__logo:after
    opacity 1
    visibility visible

</style>



// WEBPACK FOOTER //
// the-footer.vue?5ce3e7b8